import { Component, OnInit } from '@angular/core';
import { LinksService } from './services/links.service';
import { LinksModel } from './models/links.model';

@Component({
  selector: 'app-main',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  data: LinksModel;
  constructor(private dataService: LinksService) {}

  ngOnInit(): void {
    this.getCards();
  }

  private getCards(): void {
    this.dataService.getData().subscribe((data: LinksModel) => {
      this.data = data;
    });
  }
}
